import { initialStateOptions } from '@/utils/pagination-utils';
import moment from 'moment';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  searchText: null,
  statusOptions: [
    {
      id: 'TODAS',
      description: 'Todas',
      value: null,
    },
    {
      id: 'PENDENTES',
      description: 'Pendentes',
      value: () => '(situacaoEntrega = \'PENDENTE\')',
    },
    {
      id: 'ATRASADAS',
      description: 'Atrasadas',
      value: () => `(situacaoEntrega = 'PENDENTE' and dataPrevisaoEntrega < ${moment().format('YYYY-MM-DD')})`,
    },
    {
      id: 'RECEBIDAS',
      description: 'Recebidas',
      value: () => '(situacaoEntrega = \'ENTREGUE\')',
    },
  ],
  selectedStatus: {
    id: 'PENDENTES',
    description: 'Pendentes',
    value: () => '(situacaoEntrega = \'PENDENTE\')',
  },
  empresa: null,
  localEntrega: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  dataInicial: null,
  dataFinal: null,
  grupo: [],
  solicitante: [],
  fornecedor: [],
  listOptions: initialStateOptions('dataPrevisaoEntrega'),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
